// refactor sass to stylejs (no theme usage)
import { styled } from '@mui/material/styles';
import { css } from '@emotion/react';

export const StyledSentimentFilter = styled('div')(
  () => css`
    .filter-sentiment {
      .icon {
        font-size: 1.25rem;
        margin-left: 18px;
      }
    }
  `
);
